import { gql } from "@apollo/client";

export const SAVE_BUSINESS_ALERT_ROUTING_SETTINGS = gql`
  mutation SaveBusinessAlertRoutingSettings($input: BusinessAlertRoutingSettingsInput!) {
    saveBusinessAlertRoutingSettings(input: $input) {
      success
      message
      businessId
      policyJson
      residentAssignmentsJson
      updatedAt
    }
  }
`;
